import axios from 'axios';

interface IDictionary<T> { [key: string]: T; }

export interface IMsiDefinition {
	code: string;
	tag: string;
	title: string;
}

class MsiInfo {
	msi: IDictionary<IMsiDefinition> = {};

	async populate (): Promise<void> {
		const response = await axios({
			method: 'get',
			url: '/CatalogSearch/MsiTypes'
		});

		response.data.forEach((t: IMsiDefinition) => { this.msi[t.code] = { code: t.code, tag: t.tag, title: t.title }; });
	}

	getMetadata (code: string) : IMsiDefinition {
		return this.msi[code] || { code: code, tag: code, title: code };
	}
}

export const msiInfo = new MsiInfo();
